
<template>
  <zm-modal
    ref="modal"
    @ok="handleSubmit"
    :title="title"
    :visible="visible"
    size="large"
    @cancel="open(false)"
    okText="保存"
  >
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商" hasFeedback>
              <a-select
                placeholder="请选择供应商"
                :allowClear="true"
                :disabled="!isEdit"
                showSearch
                optionFilterProp="children"
                @change="changeSupplier"
                v-decorator="['supplierId', { rules: [{ required: true, message: '请选择供应商！' }] }]"
              >
                <a-select-option v-for="(option, index) in supplierList" :key="index" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" hasFeedback>
              <a-select
                placeholder="请选择联系人"
                :allowClear="true"
                :disabled="!isEdit"
                showSearch
                optionFilterProp="children"
                @change="changeContact"
                v-decorator="['supplierContactId', { rules: [{ required: true, message: '请选择联系人！' }] }]"
              >
                <a-select-option v-for="(option, index) in supplierContactList" :key="index" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系方式" hasFeedback>
              <a-input
                placeholder="自动匹配联系方式"
                autocomplete="off"
                disabled
                v-decorator="['phone', { rules: [{ required: false, message: '未匹配到联系方式！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="询价单价">
              <a-input
                placeholder="请输入询价单价"
                style="width:calc(100% - 20px)"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['inquiryPrice', { rules: [{ required: true, message: '请输入询价单价！' }] }]"
              />
              <span style="display:inline-block;width:20px;text-align:right;">元</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="询价日期" hasFeedback>
              <a-date-picker
                style="width: 100%"
                placeholder="请选择询价日期"
                :disabled="!isEdit"
                v-decorator="['inquiryTime', { rules: [{ required: true, message: '请选择询价日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联商机" hasFeedback>
              <a-select
                :allowClear="true"
                placeholder="请选择关联商机"
                :disabled="!isEdit"
                showSearch
                optionFilterProp="children"
                v-decorator="['marketId', { rules: [{ required: true, message: '请选择关联商机！' }] }]"
              >
                <a-select-option v-for="(option, index) in marketList" :key="index" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="isEdit">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="附件">
              <zm-upload
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                acceptType="doc,docx,xls,xlsx,pdf,jpeg,jpg,png"
                @handleUpload="handleUpload"
              ></zm-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-modal>
</template>

<script>
import { mapState } from 'vuex'
import { inquiryRecordDetail, saveInquiryRecord } from '@/api/inquiry'
import { getSupplierContacts, getSupplierList } from '@/api/supplier'
import { getMarketsList } from '@/api/markets'
import moment from 'moment'
export default {
  name: 'editInquiryRecord',
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({})
  },
  components: {},
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'inquiry' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      colSpan: 12,

      supplierList: [],
      supplierContactList: [],
      marketList: [],

      headers: {
        Authorization: this.$store.state.user.token
      },
      fileList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.initDictData()
        if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
          this.setModelInfo()
        }
      } else {
        this.model = {}
      }
    },
    async setModelInfo () {
      const res = await inquiryRecordDetail({ id: this.model.id }).catch(error => {
        console.log('查询失败', error)
        this.$message.error('记录详情查询失败，请稍后重试！')
      })
      const model = res.data
      console.log('model', model)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          supplierId: model.supplierId,
          supplierContactId: model.supplierContactId,
          phone: model.phone,
          inquiryPrice: model.inquiryPrice,
          inquiryTime: moment(model.inquiryTime),
          marketId: model.marketId
        })

        this.fileList = model.files
      })
      this.changeSupplier(model.supplierId)
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          params.productId = this.model.productId
          params.inquiryTime = moment(value.inquiryTime).format('YYYY-MM-DD')

          const supplier = this.supplierList.filter(item => item.id === value.supplierId)[0]
          const supplierContact = this.supplierContactList.filter(item => item.id === value.supplierContactId)[0]
          const market = this.marketList.filter(item => item.id === value.marketId)[0]
          params.supplierName = supplier.name
          params.supplierContactName = supplierContact.name
          params.marketName = market.name

          params.files = this.fileList.map(item => { return { ...item, productId: this.model.productId } })

          if (this.type === this.$sysInfo.MODAL_MODIFY) {
            params.id = this.model.id
          }
          this.$refs.modal.handleOkLoading(true)
          const res = await saveInquiryRecord(params).catch((error) => {
            this.$refs.modal.handleOkLoading(false)
            console.log('保存失败', error)
            this.$message.error('保存失败，请稍后重试！')
          })
          this.$refs.modal.handleOkLoading(false)
          if (res && res.status === 0) {
            this.$message.success(res.info.message)
            this.$emit('refreshTable')
            this.open(false)
          } else {
            this.$message.warning(res.info.message)
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
        this.fileList = []
        this.$refs.uploader.clearFileList()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
    initDictData () {
      getSupplierList({ paging: false, status: 1 }).then((res) => {
        if (res.status === 0) {
          this.supplierList = res.data
        }
      })
      getMarketsList({ paging: false, status: 'MARKET_STATUS_01' }).then(res => {
        if (res.status === 0) {
          this.marketList = res.data
        }
      })
    },
    changeSupplier (val) {
      this.form.setFieldsValue({ supplierContactId: undefined })
      if (val) {
        getSupplierContacts({ supplierId: val }).then(res => {
          if (res.status === 0) {
            this.supplierContactList = res.data
          }
        })
      } else {
        this.supplierContactList = []
      }
    },
    changeContact (val) {
      this.form.setFieldsValue({ phone: undefined })
      if (val) {
        const contact = this.supplierContactList.filter(item => item.id === val)[0]
        this.form.setFieldsValue({ phone: contact.phone1 })
      }
    },
    handleUpload (fileList) {
      this.fileList = fileList
    }
  }
}
</script>

<style lang="less">
.info_label{
  margin-bottom: 10px;
}
</style>
